import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

const AuthSequencingMenu = ({ buttons }) => (
  <Stack spacing={2} sx={{ p: 0 }}>
    {buttons}
  </Stack>
);

AuthSequencingMenu.propTypes = {
  buttons: PropTypes.node.isRequired,
};

export default AuthSequencingMenu;
